import React from 'react'
import MediaQuery from 'react-responsive'

import { breakpoints } from 'styles'

import CalendarAgendaView from './CalendarAgendaView'
import CalendarLegend from './CalendarLegend'
import CalendarMonthGrid from './CalendarMonthGrid'
import CalendarMonthNav from './CalendarMonthNav'
import { eventsInMonth, groupByDay } from './calendarHelpers'

const { phabletMax, phabletMaxPlusOne } = breakpoints

/**
 * Responsive switch only. The two views underneath stay MediaQuery-free so
 * they can be mounted in tests (jsdom has no matchMedia here).
 */
const EventsCalendarView = ({ month, bounds, events, onMonthChange }) => (
  <div>
    <CalendarMonthNav
      month={month}
      bounds={bounds}
      eventCount={eventsInMonth(groupByDay(events), month)}
      onMonthChange={onMonthChange}
    />
    <CalendarLegend />
    <MediaQuery minWidth={phabletMaxPlusOne}>
      <CalendarMonthGrid month={month} events={events} />
    </MediaQuery>
    <MediaQuery maxWidth={phabletMax}>
      <CalendarAgendaView month={month} events={events} />
    </MediaQuery>
  </div>
)

EventsCalendarView.propTypes = {
  month: React.PropTypes.object.isRequired,
  bounds: React.PropTypes.object.isRequired,
  events: React.PropTypes.array.isRequired,
  onMonthChange: React.PropTypes.func.isRequired
}

export default EventsCalendarView
